/* Import Packages */
import Vue from 'vue'
import Router from 'vue-router'

/* Assign Packages */
Vue.use(Router)

import Index from '@components/App/Index'

/* Routes */
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            name: 'Index',
            component: Index
        },
    ]
})



// WEBPACK FOOTER //
// ./resources/assets/js/router/Index.js